// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0385d17b","961":"ecd11abe"}[chunkId] + ".chunk.js";
};